import { DateTime } from 'luxon';
import { keys } from '@mantine/core';

export default class tableTools {
  static readonly severityOrder: Record<string, number> = {
    High: 3,
    Moderate: 2,
    Low: 1,
  };

  static sortDateTimes = (a?: DateTime, b?: DateTime) => {
    if (!a && !b) return 0;

    if (!a) return 1;

    if (!b) return -1;

    if (a.equals(b)) return 0;

    if (a < b) return -1;

    return 1;
  };

  static filterData(data: any[], search: string) {
    const query = search.toLowerCase().trim();
    return data.filter((item) =>
      keys(data[0]).some((key) =>
        item[key]?.toString().toLowerCase().includes(query),
      ),
    );
  }

  static sortData(
    data: any[],
    {
      sortBy,
      reversed,
      search,
    }: { sortBy: string; reversed: boolean; search: string },
  ) {
    const isDateField = [
      'startDate',
      'endDate',
      'date',
      'expirationDate',
      'dueDate',
      'dateOrdered',
      'dateMeasured',
      'orderDate',
      'billedDateTime',
      'examDate',
      'lastModifiedDate',
    ].includes(sortBy);

    const isNumericString = (val: any) =>
      typeof val === 'string' && !isNaN(Number(val)) && val.trim() !== '';

    const sorted = [...data].sort((a, b) => {
      let aValue = a[sortBy];
      let bValue = b[sortBy];

      if (isDateField) {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
        return reversed
          ? bValue.getTime() - aValue.getTime()
          : aValue.getTime() - bValue.getTime();
      }

      if (sortBy === 'severity') {
        const aOrder = tableTools.severityOrder[aValue] ?? 0;
        const bOrder = tableTools.severityOrder[bValue] ?? 0;
        if (aOrder !== bOrder)
          return reversed ? aOrder - bOrder : bOrder - aOrder;
        // Tiebreaker: triggeredDate DESC (newest first)
        const aDate = new Date(a.triggeredDate).getTime();
        const bDate = new Date(b.triggeredDate).getTime();
        return bDate - aDate;
      }

      if (isNumericString(aValue) && isNumericString(bValue))
        {return reversed
          ? Number(bValue) - Number(aValue)
          : Number(aValue) - Number(bValue);}

      if (typeof aValue === 'string' && typeof bValue === 'string')
        {return reversed
          ? bValue.localeCompare(aValue)
          : aValue.localeCompare(bValue);}

      if (typeof aValue === 'number' && typeof bValue === 'number')
        return reversed ? bValue - aValue : aValue - bValue;

      if (typeof aValue === 'boolean' && typeof bValue === 'boolean')
        {return reversed
          ? Number(bValue) - Number(aValue)
          : Number(aValue) - Number(bValue);}

      return 0;
    });

    if (search) {
      return sorted.filter((item) =>
        Object.values(item).some((value) =>
          String(value).toLowerCase().includes(search.toLowerCase()),
        ),
      );
    }

    return sorted;
  }
}
